module.exports = __webpack_public_path__ + "media/your_career_track/firefighter-hover-bae75598.png";